import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { SelectFieldComponent } from '../../../../components/form/select-field/select-field.component';
import { SelectOption } from '../../../../components/form/select-field/select-field.config';
import { InputFieldComponent } from '../../../../components/form/input-field/input-field.component';
import { TextAreaFieldComponent } from '../../../../components/form/textarea-field/textarea-field.component';
import { RiskActionProposeAttachmentsComponent } from '../risk-action-propose-attachments/risk-action-propose-attachments.component';

import { ConfirmationDialogService } from '../../../../services/confirmation-dialog.service';

import { RiskActionPropose, RiskAttachment } from '../../../../models/entities/risk';

@Component({
  selector: 'risk-action-proposes',
  imports: [
    ReactiveFormsModule,
    InputFieldComponent,
    SelectFieldComponent,
    TextAreaFieldComponent,
    RiskActionProposeAttachmentsComponent
  ],
  templateUrl: './risk-action-proposes.component.html',
  styleUrl: './risk-action-proposes.component.scss'
})
export class RiskActionProposesComponent {

  @Input({ required: true }) actionProposes!: FormArray<FormGroup>;
  @Input() riskId?: number | null;
  @Input() responsibleOptions: SelectOption[] = [];
  @Input() timeFrameOptions: SelectOption[] = [];
  @Input() readonlyRows: boolean = false;

  @Output() addRow = new EventEmitter<void>();
  @Output() removeRow = new EventEmitter<number>();
  @Output() attachmentUploaded = new EventEmitter<void>();

  constructor(private confirmationDialogService: ConfirmationDialogService) { }

  get rows(): FormGroup[] {
    return this.actionProposes?.controls ?? [];
  }

  getControl(row: FormGroup, name: string): FormControl {
    return row.get(name) as FormControl;
  }

  rowActionProposeId(row: FormGroup): number | null {
    const value = row.get('riskActionProposeId')?.value;
    return value == null || value === '' ? null : Number(value);
  }

  rowAttachments(row: FormGroup): RiskAttachment[] {
    return (row.get('attachments')?.value as RiskAttachment[]) ?? [];
  }

  trackRow(_index: number, row: FormGroup): FormGroup {
    return row;
  }

  onAddRow(): void {
    this.addRow.emit();
  }

  onRemoveRow(index: number): void {
    const row = this.rows[index];

    if (!row) {
      return;
    }

    if (!this.rowActionProposeId(row)) {
      this.removeRow.emit(index);
      return;
    }

    this.confirmationDialogService.open(
      'Are you confident in your decision to remove this action propose? It will be deleted when you save the risk.',
      () => this.removeRow.emit(index)
    );
  }
}
